// extracted by mini-css-extract-plugin
module.exports = {"addInitialCard__block":"style_addInitialCard__block__3FHk3","initialFooter":"style_initialFooter__Mtmf9","addInitialCard":"style_addInitialCard__3RzPn"};